// Build flag of partner access. It gates the ENTRY POINTS of the feature (the
// sede directory, the switcher in the profile menu, the `?sede=` handoff):
// with the flag off none of them renders anything or makes a request.
//
// Only the exact string "true" turns it on (fail-closed). `vite.config.js`
// always defines the variable, so an unset one compiles to "".
export const isPartnerAccessEnabled = () =>
  process.env.REACT_APP_PARTNER_ACCESS_ENABLED === "true";
